/** @format */

export enum FeatureConfigurationKeys {
	ADD_DRAWER = 'addDrawer',
	PRESELECT_PDP_BY_SIZE = 'preselectPDPBySize',
	SET_PRODUCT_CUSTOM_BADGE = 'setProductCustomBadge',
}
